import { render, staticRenderFns } from "./TenantEdit.vue?vue&type=template&id=c51357d2&scoped=true&lang=pug&"
import script from "./TenantEdit.vue?vue&type=script&lang=js&"
export * from "./TenantEdit.vue?vue&type=script&lang=js&"
import style0 from "./TenantEdit.vue?vue&type=style&index=0&id=c51357d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51357d2",
  null
  
)

export default component.exports